import React, { Suspense, useContext } from "react";
import { useEffect, useState } from "react";
import OnboardingRoutes from "routes/router";
import PropagateLoader from "react-spinners/PropagateLoader";
import { MobXProviderContext } from "mobx-react";

const FreshChatComponent = React.lazy(() =>
  import("components/freshChat/FreshChat")
);

const Loading = () => (
  <div className="d-row justify-center items-center">
    <PropagateLoader color={"#DA2D8B"} loading={true} size={15} />
  </div>
);

function App() {
  const { onboardingStore } = useContext(MobXProviderContext);

  if (!window.store) window.store = onboardingStore;

  const [showFreshChat, setShowFreshChat] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFreshChat(true);
    }, 4000); // 4 seconds delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-row">
      <Suspense fallback={<Loading />}>
        <OnboardingRoutes />

        {showFreshChat && <FreshChatComponent />}
      </Suspense>
    </div>
  );
}

export default App;
